import instance from '../utils/axios';

export const getOpenBetByEvent = async (eventId) => {
    const response = await instance.get(`/api/betting/get-all-open-bet-by-event/${eventId}`);
    return response.data;
};

export const deleteOpenBetByEvent = async (bettingId) => {
    const response = await instance.delete(`/api/betting/delete-bet-by-betting-id/${bettingId}`);
    return response.data;
};
